import { DOC_FIELD_TYPES } from 'constants/documentFieldTypes';

export const ENUM_TYPE = 'enum';
export const documentExtractionFieldsTypesMapping = {
  [DOC_FIELD_TYPES.TEXT]: ['string', 'guid'],
  [DOC_FIELD_TYPES.BOOL]: ['bool'],
  [DOC_FIELD_TYPES.INTEGER]: ['int'],
  [DOC_FIELD_TYPES.DOUBLE]: ['decimal', 'double', 'long', 'float'],
  [DOC_FIELD_TYPES.SINGLE_SELECTION_DROP_DOWN]: [ENUM_TYPE],
  [DOC_FIELD_TYPES.DATE]: ['date'],
  [DOC_FIELD_TYPES.COMPLEX]: ['string'],
};

export const typesToExcludeFromAiExtractionModelMapping = [
  DOC_FIELD_TYPES.TABLE,
  DOC_FIELD_TYPES.SINGLE_SELECTION_DROP_DOWN,
  DOC_FIELD_TYPES.MULTIPLE_SELECTION_DROP_DOWN,
  DOC_FIELD_TYPES.DROP_DOWN_FIELD,
];
